import Routers from './route';
import { RecoilRoot } from 'recoil';
import { ToastContainer } from 'react-toastify';

function App() {
    return (
        <RecoilRoot>
            <Routers />
            <ToastContainer />
        </RecoilRoot>
    );
}

export default App;
